<template>
  <div class="pt-5 pl-3 pr-3">
    <div class="summary">
      <h3 class="tNormal">لیست فروشگاه ها</h3>
      <div class="search-section row">
        <div class="col-3">
          <custom-input
            kind="text"
            container="full-width"
            classes="full-width pb-2 pr-1"
            v-bind:theModel.sync="shopMobile"
            label="جستجوی کاربر"
            placeholder="شماره موبایل"
          ></custom-input>
        </div>
        <div class="col-3">
          <custom-input
            kind="searchInput"
            @addTag="selectDistrict"
            container="full-width"
            classes="full-width pb-2 pr-1"
            :suggestions="districts"
            v-bind:theModel.sync="theDistrict"
            label="منطقه"
            :placeholder="theDistrict.value != null ? '' : 'منطقه'"
          >
            <p v-if="theDistrict.value != null">{{ theDistrict.value.name }}</p>
          </custom-input>
        </div>
        <div class="col-3">
          <custom-input
            kind="dropDown"
            container="full-width"
            classes="full-width pb-0"
            :selectItems="categories"
            v-bind:theModel.sync="theCategory"
            label="دسته بندی"
            placeholder="دسته بندی"
          ></custom-input>
        </div>
        <div class="col-1 mt-1 pt-4">
          <button class="purple-btn mt-2" @click="search">جستجو</button>
        </div>
        <div class="col-1 mt-1 pt-4">
          <router-link to="/map"><button class="purple-btn mt-2">لوکیشن</button></router-link>
          <router-view></router-view>
        </div>
      </div>
      <table class="mt-2">
        <tr>
          <th class="small-cell">نام فروشگاه</th>
          <th class="small-cell">نام فروشنده</th>
          <th class="small-cell">شماره تلفن</th>
          <th class="mid-cell">آدرس</th>
          <th class="small-cell">منطقه</th>
          <th class="small-cell">وضعیت فروشگاه</th>
          <th class="small-cell">نامک</th>
          <th class="small-cell">گزینه ها</th>
        </tr>
        <one-shop
          @slugMe="openSlugModal"
          @changeMe="changeShopStatus"
          @goToPanel="goToPanel"
          v-for="(shop, i) in shops"
          :key="i"
          :theShop="shop"
        ></one-shop>
      </table>
    </div>
    <div class="modal" id="slugModal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="p-3 d-flex justify-content-between">
            <h5 class="modal-title">افزودن و تغییرات سئو</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <custom-input
              kind="text"
              key="12"
              container="full-width ml-3 mt-3"
              classes="full-width"
              v-bind:theModel.sync="shopSlug.title_seo"
              label="عنوان سئو"
              placeholder=""
            ></custom-input>
            <custom-input
              kind="text"
              key="13"
              container="full-width ml-3 mt-3"
              classes="full-width"
              v-bind:theModel.sync="shopSlug.slug"
              label="نامک"
              placeholder=""
            ></custom-input>
            <custom-input
              kind="text"
              key="14"
              container="full-width ml-3 mt-3"
              classes="full-width"
              v-bind:theModel.sync="shopSlug.editor"
              label="ادیتور"
              placeholder=""
            ></custom-input>
            <custom-input
              kind="text"
              key="15"
              container="full-width ml-3 mt-3"
              classes="full-width"
              v-bind:theModel.sync="shopSlug.meta_desc"
              label="توضیحات متا"
              placeholder=""
            ></custom-input>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="addSlug">
              <span>ثبت تغییرات</span>
              <span v-if="loading" class="mr-2"
                ><v-progress-circular
                  :size="20"
                  color="primary"
                  indeterminate
                ></v-progress-circular
              ></span>
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              بستن
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { computed, inject, onMounted, ref } from "@vue/composition-api";
import OneShop from "./partials/OneShopRow";
import Service from "../../../utils/admin-service";
import CustomInput from "../../Common/CustomInput";
import $ from "jquery";
export default {
  components: {
    OneShop,
    CustomInput,
  },
  setup(props, context) {
    const shops = ref(null);
    const shopMobile = ref({ value: null, valid: true });
    const districts = ref([]);
    const categories = ref([]);
    const theCategory = ref({ value: null, valid: true });
    const theDistrict = ref({ value: null, valid: true });
    const theService = computed(() => {
      return Service(false);
    });
    const authService = computed(() => {
      return Service(true);
    });
    const global = inject("global");
    onMounted(() => {
      theService.value.receive(
        "admin/category",
        {},
        (s, d) => {
          if (s == 200) {
            let x = d.data;
            x.map((c) => {
              c.text = c.name;
              c.value = c.id;
            });
            categories.value = x;
            categories.value = [
              { value: null, text: "تمامی دسته بندی ها" },
            ].concat(categories.value);
          }
        },
        (s, e) => {}
      );
      theService.value.receive(
        "admin/district/1",
        {},
        (s, d) => {
          if (s == 200) {
            let x = d.data;
            x.map((xd) => {
              xd.text = xd.name;
              xd.value = xd.id;
            });
            districts.value = x;
          }
        },
        (s, e) => {}
      );
      getAllShops();
    });

    const selectDistrict = (v) => {
      theDistrict.value.value = v;
    };

    const getAllShops = () => {
      theService.value.receive(
        "admin/seller/search",
        {},
        (s, d) => {
          if (s == 200) {
            shops.value = d.data;
          }
        },
        (s, e) => {}
      );
    };

    const search = () => {
      let q = "";
      if (theCategory.value.value != null) {
        if (theCategory.value.value.value != null)
          q = "category_id=" + theCategory.value.value.value;
      }
      if (theDistrict.value.value != null) {
        q =
          (q == "" ? q : q + "&") +
          "district_id=" +
          theDistrict.value.value.value;
      }
      if (shopMobile.value.value != null) {
        q = (q == "" ? q : q + "&") + "mobile=" + shopMobile.value.value;
      }
      theService.value.receive(
        "admin/seller/search?" + q,
        {},
        (s, d) => {
          if (s == 200) {
            shops.value = d.data;
          }
        },
        (s, e) => {}
      );
    };

    const goToPanel = (id) => {
      theService.value.receive(
        "admin/seller/return/token/" + id,
        {},
        (s, d) => {
          // global.toggleLogin(true)
          // global.setUserType('seller')
          // let routeData = context.root.$router.resolve({name: 'Golpino Seller Settings'})
          // window.open(routeData.href, '_blank')
          document.cookie =
            "Golpino_seller=" + d.data + ";path=/;domain=golpino.com";
          window.open("http://seller.golpino.com/seller/dashboard", "_blank");
          // $cookies.set("Golpino_seller",d.data,2147483647)
        },
        (s, e) => {}
      );
    };

    const changeShopStatus = (targ) => {
      if (targ.active == 1) {
        theService.value.transmit(
          "admin/seller/disable/" + targ.id,
          {},
          (s, d) => {
            alert("با موفقیت ثبت شد");
            getAllShops();
          },
          (s, e) => {}
        );
      } else {
        theService.value.transmit(
          "admin/seller/enable/" + targ.id,
          {},
          (s, d) => {
            alert("با موفقیت ثبت شد");
            getAllShops();
          },
          (s, e) => {}
        );
      }
    };
    const shopSlug = ref({
      slug: { value: null, valid: true },
      editor: { value: null, valid: true },
      title_seo: { value: null, valid: true },
      meta_desc: { value: null, valid: true },
    });
    const get_slugs = function (this_id) {
      theService.value.receive(
        "admin/seo/seller/" + this_id,
        {},
        my_response,
        failedAdd
      );
    };
    const my_response = (status, data) => {
      store_slug.value = data.data;
      shopSlug.value.slug.value = data.data.slug;
      shopSlug.value.editor.value = data.data.editor;
      shopSlug.value.title_seo.value = data.data.title_seo;
      shopSlug.value.meta_desc.value = data.data.meta_desc;
    };
    const store_slug = ref({});
    const shopSlugId = ref(null);
    const openSlugModal = (id) => {
      shopSlugId.value = id;
      $("#slugModal").modal("show");
      get_slugs(id);
    };
    const addSlug = () => {
      loading.value = true;
      let f = new FormData();
      if (store_slug.value.slug != shopSlug.value.slug.value)
        f.append("slug", shopSlug.value.slug.value);
      if (store_slug.value.editor != shopSlug.value.editor.value)
        f.append("editor", shopSlug.value.editor.value);
      if (store_slug.value.title_seo != shopSlug.value.title_seo.value)
        f.append("title_seo", shopSlug.value.title_seo.value);
      if (store_slug.value.meta_desc != shopSlug.value.meta_desc.value)
        f.append("meta_desc", shopSlug.value.meta_desc.value);

      // f.append("editor", shopSlug.value.editor.value);
      // f.append("title_seo", shopSlug.value.title_seo.value);
      // f.append("meta_desc", shopSlug.value.meta_desc.value);

      theService.value.transmit(
        "admin/seo/seller/" + shopSlugId.value,
        f,
        (s, d) => {
          global.alertToggle("با موفقیت ثبت شد");
          loading.value = false;
        },
        failedAdd
      );
    };
    const failedAdd = (server, e) => {
      var my_errors;
      console.log(e.response.data.error.invalid_params);
      e.response.data.error.invalid_params.forEach((element) => {
        my_errors = my_errors
          ? element.message + " <br> " + my_errors
          : element.message;
      });
      global.alertToggle(my_errors);
      loading.value = false;
    };
    const loading = ref(false);
    return {
      store_slug,
      loading,
      failedAdd,
      changeShopStatus,
      search,
      selectDistrict,
      theCategory,
      shopSlug,
      openSlugModal,
      addSlug,
      theDistrict,
      districts,
      categories,
      shops,
      shopMobile,
      goToPanel,
      get_slugs,
      authService,
      my_response,
    };
  },
};
</script>
<style scoped>
.summary {
  background-color: #fff;
  font-size: 0.9rem;
  font-weight: lighter;
  min-height: 50vh;
  /* width: 100vw; */
}

.search-section {
  border-bottom: 1px solid rgba(127, 127, 127, 0.2);
  padding-bottom: 0.5rem;
}

table {
  border-collapse: separate;
  border-spacing: 0px;
  width: 100%;
  table-layout: fixed;
  text-align: center;
}

td {
  border: 1px solid rgba(127, 127, 127, 0.2);
  white-space: nowrap;
  padding-right: 1rem;
}

tr {
  width: 100%;
}

.big-cell {
  width: 75%;
  padding: 0.5rem 1rem 0.5rem 1rem;
}
.mid-cell {
  max-width: 12.5%;
  padding: 0.5rem 1rem 0.5rem 1rem;
}
.small-cell {
  max-width: 10%;
  padding: 0.5rem 1rem 0.5rem 1rem;
}
.modal-footer {
  color: #fff;
}
</style>